import { baseApi } from "@/redux/api/base-api";
import { IHttpResponse } from "@/types/api-response";
import {
  IHolidaySearchQueryParams,
  IHolidaySearchQueryArgs,
  IHolidaySearchResult,
} from "../types/holiday-search-type";
import { setHolidayForExtractFilter } from "../state/extract-holiday-filter-slice";

let lastSearchQueryArgStr: string | null = null;

function getSearchParams(arg: IHolidaySearchQueryArgs): IHolidaySearchQueryParams {
  return arg.searchParams ?? {};
}

export const holidaySearch = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    searchHoliday: builder.query<
      IHttpResponse<IHolidaySearchResult[]>,
      IHolidaySearchQueryArgs
    >({
      query: ({ city_id }) => ({
        url: "/b2c/holiday/search",
        method: "POST",
        params: city_id ? { city_id } : undefined,
      }),
      providesTags: ["HOLIDAY_SEARCH"],
      keepUnusedDataFor: 0,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        const currentArgStr = JSON.stringify(arg);
        const isRefresh = lastSearchQueryArgStr === currentArgStr;
        lastSearchQueryArgStr = currentArgStr;

        try {
          const { data } = await queryFulfilled;
          dispatch(
            setHolidayForExtractFilter({
              results: data?.data ?? [],
              searchParams: getSearchParams(arg),
              keepFilters: isRefresh,
            }),
          );
        } catch {
          // handled by query error state
        }
      },
      async onCacheEntryAdded(arg, { dispatch, cacheDataLoaded, getCacheEntry }) {
        try {
          await cacheDataLoaded;
          const entry = getCacheEntry();

          if (entry.status === "fulfilled") {
            const currentArgStr = JSON.stringify(arg);
            const isRefresh = lastSearchQueryArgStr === currentArgStr;
            lastSearchQueryArgStr = currentArgStr;

            dispatch(
              setHolidayForExtractFilter({
                results: entry.data?.data ?? [],
                searchParams: getSearchParams(arg),
                keepFilters: isRefresh,
              }),
            );
          }
        } catch {
          // no-op
        }
      },
    }),
  }),
});

export const { useSearchHolidayQuery } = holidaySearch;
